/**
 * Created by rathompson on 11/1/21
 * File: SelectTab
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { forwardRef, useEffect, useRef, useState } from 'react'
import { classNames, Select, TruncateText, MenuIcon } from '@panwds/react-ui'

const SelectTab = ({ items, onChange, selectedItem, ...props }) => {
  const buttonRef = useRef(null)
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    if (props.hasFocus) buttonRef?.current?.focus()
  }, [props.hasFocus, buttonRef])

  const buttonProps = {
    ...props,
    tabIndex: props.hasFocus ? 0 : -1,
  }

  return (
    <TabButton {...buttonProps} ref={buttonRef}>
      <div className="tw-flex tw-gap-2 tw-items-center">
        <TruncateText>{props.children}</TruncateText>
        <div onClick={event => event.stopPropagation()}>
          <Select
            addClassName='cmm-modal-select'
            defaultPlacement='bottom'
            fitToItemWidth
            onOpen={() => setIsOpen(!isOpen)}
            {...{ items, onChange, selectedItem }}
            button={
              <div>
                <MenuIcon
                  size='xxs'
                  isOpen={isOpen}
                // isSplit={isSplit}
                // isBtnGroup={isBtnGroup}
                />
              </div>
            }
          />
        </div>
      </div>
    </TabButton>
  )
}

const TabButton = forwardRef(({
  id,
  active = false,
  children,
  disabled = false,
  onClick,
  onKeyDown,
  tabIndex,
}, ref) => {
  const className = classNames(
    'tw-box-border tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-bg-transparent tw-flex tw-items-center tw-px-4 tw-h-8 tw-border-transparent',
    'focus:tw-outline-none focus:tw-ring focus:tw-ring-inset tw-box-content',
    disabled ? 'tw-cursor-not-allowed tw-text-disabled tw-text-sm' : 'hover:tw-bg-blue-100 ',
    active ? 'tw-border-b-2 tw-border-blue-600' : 'tw-border-b',
  )

  return (
    <button
      id={'test'}
      role="tab"
      aria-selected={active}
      type="button"
      style={{ maxWidth: 'fit-content', marginBottom: '-1px' }}
      {...{ id, className, disabled, tabIndex, ref }}
    >
      {children}
    </button>
  )
})

TabButton.displayName = 'Button'

export default SelectTab
